import { allowedFileFormats, uploadFileMaxSize } from '../constants/globals';

export const returnFileFormat = (documentType) => {
  let format = documentType.substring(
    documentType.lastIndexOf('/') + 1,
    documentType.length
  );
  return format;
};

export const checkFileFormat = (
  files,
  allowedFormats = allowedFileFormats?.split(', ')
) => {
  for (const element of files) {
    let format = returnFileFormat(element.type);
    const customAllowedFormats = allowedFormats?.map((allowedFormat) =>
      mapAdequateFormat(allowedFormat)
    );
    if (!customAllowedFormats.includes(format)) {
      return true;
    }
  }
  return false;
};

export const checkFilesSize = (files) => {
  let size = 0;
  for (const element of files) {
    size += element.size;
  }
  return size > uploadFileMaxSize;
};

export const getFilesForUpload = (files) => {
  const arrayLength = files.length;
  if (arrayLength !== 0) {
    let uploadedArray = [];
    for (let i = 0; i < arrayLength; i++) {
      uploadedArray.push(files[i]);
    }
    return uploadedArray;
  } else {
    return null;
  }
};

function mapAdequateFormat(format) {
  const properFormat = format?.startsWith('.') ? format.substring('1') : format;
  switch (properFormat) {
    case 'docx':
      return 'vnd.openxmlformats-officedocument.wordprocessingml.document';
    case 'xlsx':
      return 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'doc':
      return 'msword';
    case 'xls':
      return 'vnd.ms-excel';
    case 'txt':
      return 'plain';
    case 'zip':
      return 'x-zip-compressed';
    case 'mp3':
      return 'mpeg';
    case 'jpg':
      return 'jpeg';
    case 'rar':
      return '';
    case 'mov':
      return 'quicktime';
    default:
      return properFormat;
  }
}
